export default __webpack_public_path__ + "static/media/bell-notif.a38b204f.svg";